// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  defaultTheme: 'nfl',
  production: false,
  amplifyEnv: 'dev',
  serviceEnv: 'dev',
  domain: 'https://intldatahub-dev.dna.nfl.net',
  contactUsLink: 'https://nfldev.service-now.com/esc?id=sc_cat_item&sys_id=7a9a1c09c312c714e3f638cc050131a6',
  region: 'us-east-1',
  auth: {
    hostname: 'idh-dev-login.auth.us-east-1.amazoncognito.com',
    redirect_uri: ['https://intldatahub-dev.dna.nfl.net/login'],
    response_type: 'code',
    client_id: 'lo6q0i2j3v4jtkm0qbsb3omfd',
    scope: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
    user_pool_id: 'us-east-1_KLORFSRq6',
    identity_pool_id: 'us-east-1:40053a7d-fb47-47d7-b8be-d0dc0caa9a29',
    domain: 'intldatahub-dev.dna.nfl.net',
  },
  api: {
    aws_appsync_graphqlEndpoint: 'https://intldatahub-dev.dna.nfl.net/graphql',
    aws_appsync_region: 'us-east-1',
    aws_appsync_authenticationType: 'userPool',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
